module.exports = __webpack_public_path__ + "img/ico-dash-shop.7ce57a31.svg";